<!-- Composant qui permet de réutiliser du code entre ListeInscriptionsListeAttente et ListeInscriptionsPayees pour éviter de la répétition -->
<template>
  <div>
    <RetirerListeAttenteDialogVue ref="dialogueRetirerInscription" />
    <AnnulationInscriptionDialog
      v-on:echecRemboursement="echecRemboursement"
      ref="dialogueAnnulation"
    />
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';
import usePaiementStore from '@/store/paiementStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import { TypeCours, EtatCoursEleve, RaisonTransaction } from '@/outils/Enum';
import RetirerListeAttenteDialogVue from './dialogues/RetirerListeAttenteDialog.vue';
import AnnulationInscriptionDialog from './dialogues/AnnulationInscriptionDialog.vue';

export default {
  name: 'LogiqueListe',
  setup() {
    const appStore = useAppStore();
    const paiementStore = usePaiementStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return {
      appStore, paiementStore, inscriptionStore, panierStore,
    };
  },
  components: {
    RetirerListeAttenteDialogVue,
    AnnulationInscriptionDialog,
  },
  methods: {
    dialogueRetirerInscription(cours) {
      this.$refs.dialogueRetirerInscription.ouvrirDialog(cours);
    },
    obtenirEtatInscription(cours) {
      // Affichage des états de l'inscription
      let etat = '';

      // Affichage des états
      if (cours.listeAttente != null) {
        // Inscriptions sur la liste d'attente. Si le cours est "Approuvé en attente de paiement", "Annulé par parent", "Annulé par CSS ou "AttenteApproAttentePaiement", l'afficher sinon c'est sur liste d'attente
        const coursEleveId = cours.etatCoursEleveId;
        if (coursEleveId === EtatCoursEleve.ApprouveEnAttentePaiement ||
          coursEleveId === EtatCoursEleve.AnnulerParCSS ||
          coursEleveId === EtatCoursEleve.AnnulerParParent ||
          coursEleveId === EtatCoursEleve.AttenteApproAttentePaiement
        ) {
          etat = this.$tc(`enum.EtatCoursEleve.${cours.etatCoursEleveId}`);
        } else {
          etat = this.$tc('Paiement.listeInscriptionsListeAttente.enAttente');
        }
      } else {
        // Inscriptions payées
        Object.values(EtatCoursEleve).forEach((value) => {
          if (value === cours.etatCoursEleveId) {
            etat = this.$tc(`enum.EtatCoursEleve.${cours.etatCoursEleveId}`);
          }
        });
      }
      return etat;
    },
    dialogueAnnulationInscription(cours) {
      this.$refs.dialogueAnnulation.ouvrirDialog(cours);
    },
    correctionAffichageMobile(estMobile) {
      if (estMobile) {
        return 'boutonsMobile';
      }
      return '';
    },
    async payer(cours) {
      // Call backend qui check si tu peux Payer ou non avant de rediriger (selon coursEleveId)
      await this.paiementStore.verifierSiPeutPayer(cours.coursEleveId);
      const { peutPayer } = this.paiementStore;

      if (peutPayer) {
        // Obtention de l'id du cours selon le coursEleveId (quand Payer est cliqué, c'est toujours un seul cours)
        await this.paiementStore.definirCoursIdSelonCoursEleveId(cours.coursEleveId);
        const coursId = this.paiementStore.coursIdPourProcederPaiement;

        // Si le coursId est égal à -1, il y a eu une erreur dans le backend, donc une erreur est emit
        if (coursId === -1) {
          this.$emit('peutPasPayer', this.$t('Paiement.erreur.erreurObtentionCours'));
          return;
        }

        // Ajouter le cours dans le panier s'il n'est pas présent dedans
        const dejaDansPanier = this.panierStore.listeCoursPanier.find((x) => x.id === coursId);
        if (dejaDansPanier === undefined) {
          // Si l'id du cours est null, undefined ou 0, l'affecter dans le cours
          if (cours.id === null || cours.id === undefined || cours.id === 0) {
            cours.id = coursId;
          }

          this.panierStore.listeCoursPanier.push(cours);
        }

        // Avant de rediriger vers la page de paiement, s'assurer qu'aucun des cours du panier ne sont pas déjà achetés
        const listeCoursId = [];
        const coursPanier = this.panierStore.listeCoursPanier;
        for (let cpt = 0; cpt < coursPanier.length; cpt += 1) {
          listeCoursId.push(coursPanier[cpt].id);
        }
        await this.paiementStore.verifierCoursEstDejaAchete(cours.coursEleveId);
        const { coursDejaAchete } = this;

        // S'il y a déjà des cours achetés ou annulés, les retirer du panier
        if (coursDejaAchete) {
          const nomCoursDejaAchete = coursDejaAchete.map(({ coursAchete }) => coursAchete.titre);
          this.$emit('peutPasPayer', this.$t('erreurs.CleCoursDejaAchete', { cours: nomCoursDejaAchete }));
          return;
        }
        window.location.href = `${this.appStore.modele.urlBase}/#/Paiement`;
      } else {
        this.$emit('peutPasPayer', this.$t('Paiement.erreur.impossiblePayer'));
      }
    },
    obtenirTypeCoursClasse(valeur) {
      if (valeur === TypeCours.Virtuel) {
        return 'titreBoiteCours';
      } if (valeur === TypeCours.Presentiel) {
        return 'titreBoiteCours rougeImportant';
      }
      return '';
    },
    obtenirTypeCoursLabel(valeur, estExamen) {
      // Si c'est un examen, on affiche les labels d'exam à la place
      if (estExamen) {
        return this.$t(`enum.ModaliteExamen.${valeur}`);
      }

      // Sinon, c'est ceux des cours réguliers
      if (valeur === TypeCours.Virtuel) {
        return this.$t('boutique.boiteListeCours.TypeCoursVirtuel');
      } if (valeur === TypeCours.Presentiel) {
        return this.$t('boutique.boiteListeCours.TypeCoursPresentiel');
      }
      return '';
    },
    async definirBlocs(blocsId) {
      await this.paiementStore.definirBlocsSelonId(blocsId);
      return this.paiementStore.blocs;
    },
    async definirTransactions(listeCoursEleveId) {
      await this.paiementStore.definirTransactionsSelonId(listeCoursEleveId);
      return this.paiementStore.transactions;
    },
    echecRemboursement(messageEchecRemboursement) {
      this.$emit('echecRemboursement', messageEchecRemboursement);
    },
    obtenirEtatTransaction(etatRaisonTransaction) {
      let etat = '';
      Object.values(RaisonTransaction).forEach((value) => {
        if (value === etatRaisonTransaction) {
          etat = this.$tc(`enum.RaisonTransaction.${etatRaisonTransaction}`);
        }
      });
      return etat;
    },
    peutAnnulerCours(cours) {
      // Cacher le bouton selon les états spécifiés
      const boutonAnnulerCache = false;
      const etatsQuiCachentBoutonAnnuler = [
        EtatCoursEleve.AnnulerParCSS,
        EtatCoursEleve.AnnulerParParent,
        EtatCoursEleve.DesistementParParent,
        EtatCoursEleve.Refuser,
        EtatCoursEleve.AbandonSansRemboursement,
      ];
      if (etatsQuiCachentBoutonAnnuler.includes(cours.etatCoursEleveId)) {
        return boutonAnnulerCache;
      }

      // Cacher le bouton si a été offert gratuitement
      if (cours.estGratuit) {
        return boutonAnnulerCache;
      }

      // Date de début du cours ou de l'examen
      const dateDuJourYYYYMMDD = new Date().toISOString().slice(0, 10);
      const boutonAnnuleAffiche = true;

      const { dateDebut } = cours.datesHeuresBlocs;
      if (Date.parse(dateDebut) < Date.parse(dateDuJourYYYYMMDD)) {
        return boutonAnnulerCache;
      }
      return boutonAnnuleAffiche;
    },
    etatsPourPouvoirPayer() {
      // Si un nouvel état est ajouté ici, il faut également le faire dans la méthode VerifierSiPeutPayer dans le backend
      const etatsValides = [
        EtatCoursEleve.ApprouveEnAttentePaiement,
        EtatCoursEleve.AttenteApproAttentePaiement,
      ];
      return etatsValides;
    },
    determinerNombreColonnesBoutons(etats) {
      if (etats.sectionUnique) {
        return 8;
      }
      return 12; // De base
    },
    determinerNombreColonnesDesc(etats) {
      if (etats.sectionUnique) {
        return 4;
      }
      return 12; // De base
    },
  },
  computed: {
  },
};
</script>
